import { FC, memo } from 'react'
import { Button } from 'components/extend/Button/Button'
import { TextContent } from 'components/TextContent'
import { KDVID_FRONT_INDIVIDUAL_URL } from 'constants/global'

type ModalUserInfoProps = {
  isCompleteUserDocument: boolean
  isCompleteUserName: boolean
}

export const USER_INFO_NODE_ID = 'user_info_container'

export const ModalUserInfo: FC<ModalUserInfoProps> = memo(({ isCompleteUserName, isCompleteUserDocument }) => (
  <>
    <div className="h-max rounded-lg bg-attention-container px-6 pb-6 pt-4" id={USER_INFO_NODE_ID}>
      <h1 className="mb-4 text-title-md">Предоставьте доступ к вашим персональным данным</h1>
      <TextContent>
        <p>Для оформления заявки и подготовки документов на перевозку требуются ваши данные. Чтоб предоставить их:</p>
        <ol>
          <li>Перейдите в личный кабинет KDV ID;</li>
          <li>
            В личном кабинете заполните ваши Фамилию, Имя, Отчество и документ удостоверяющий личность (паспорт,
            водительское удостоверение, заграничный паспорт);
          </li>
          <li>Проверьте что учётная запись, привязанная к сайту QP5 Express, предоставляет доступ к вашим данным.</li>
        </ol>
        {/* <p className="mt-6 text-body-sm text-on-surface-variant">
          KDV ID — это сервис для надежной авторизации для российских сайтов и приложений. Пользователи с учётной
          записью в KDV ID получают быстрый вход без ввода данных и могут сразу же начать работать.
        </p> */}
      </TextContent>
      <Button
        appearance="primary"
        className="mt-4 px-1 font-medium"
        size="lg"
        onClick={() => {
          window.open(KDVID_FRONT_INDIVIDUAL_URL || '', '_blank')
        }}
      >
        Редактировать в KDV ID
      </Button>
    </div>
    {(!isCompleteUserName || !isCompleteUserDocument) && (
      <ul className="my-2 ml-5 list-disc text-body-sm text-negative">
        {!isCompleteUserName && <li>Невозможно оформить заявку без ваших Фамилии Имени и Отчества (если есть)</li>}
        {!isCompleteUserDocument && <li>Невозможно оформить заявку без данных документа, удостоверяющего личность</li>}
      </ul>
    )}
  </>
))
